import type { JSX } from 'react';
import { useStorefront } from '../brand/storefront-context.js';
import { useI18n } from '../i18n/context.js';

/** The brand's own mark, drawn by the brand (`Storefront.logo`); the app only sizes it. */
export function BrandLogo({ size = 'sm' }: { readonly size?: 'sm' | 'md' }): JSX.Element {
  const storefront = useStorefront();
  const { locale } = useI18n();
  return <>{storefront.logo({ size, locale })}</>;
}
